import React from 'react';
import { useTranslation } from 'react-i18next';

const Toggle = ({ name, label, description, checked, onChange, disabled }) => (
  <div>
    <label className="flex items-center justify-between cursor-pointer">
      <span className="font-semibold text-neutral-800 dark:text-neutral-200">
        {label}
      </span>
      <div className="relative">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="sr-only"
        />
        <div
          className={`block w-12 h-6 rounded-full transition-colors ${
            checked ? 'bg-primary' : 'bg-neutral-300 dark:bg-neutral-600'
          }`}
        ></div>
        <div
          className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full shadow-sm transition-transform ${
            checked ? 'translate-x-6' : ''
          }`}
        ></div>
      </div>
    </label>
    <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">
      {description}
    </p>
  </div>
);

const ContentOptionsForm = ({
  isPublic,
  isPremium,
  onChange,
  disabled,
  publicText, // This prop can now be removed if not used elsewhere
  premiumText, // This prop can now be removed if not used elsewhere
}) => {
  const { t } = useTranslation();

  return (
    <div className="py-4 border-y border-neutral-200 dark:border-neutral-700 mt-2 grid gap-4">
      <Toggle
        name="isPublic"
        label={
          publicText || t('posts.create_modal.content_options.public_label')
        }
        description={t('posts.create_modal.content_options.public_desc')}
        checked={isPublic}
        onChange={onChange}
        disabled={disabled}
      />
      <Toggle
        name="isPremium"
        label={
          premiumText || t('posts.create_modal.content_options.premium_label')
        }
        description={t('posts.create_modal.content_options.premium_desc')}
        checked={isPremium}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default ContentOptionsForm;
